export { default } from './BMI';
